import CustomModal from 'components/global/CustomModal'
import ItemsToBring from '../ModalCotent/ItemsToBring'

interface ItemsToBringModalProps {
  openModal: boolean
  closeModal: (state: boolean) => void
  prevItems: string[]
  setPrevItems: React.Dispatch<React.SetStateAction<string[]>>
  organizationId: string
}

const ItemsToBringModal = ({
  openModal,
  closeModal,
  prevItems,
  setPrevItems,
  organizationId,
}) => {
  const handleClose = () => {
    closeModal(false)
  }
  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title="items to bring"
        footer={false}
      >
        <ItemsToBring
          closeMdoal={closeModal}
          prevItems={prevItems}
          setPrevItems={setPrevItems}
          organizationId={organizationId}
        />
      </CustomModal>
    </>
  )
}

export default ItemsToBringModal
